module.exports = __webpack_public_path__ + "static/media/25.beb58cf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/25.png
// module id = 392
// module chunks = 0